import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=0d3e6d96&"
import script from "./InputCheckbox.vue?vue&type=script&lang=ts&"
export * from "./InputCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./InputCheckbox.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports